/** @jsx jsx */
import { forwardRef } from 'react';
import { cssMap, jsx } from '@atlaskit/css';
import { token } from '@atlaskit/tokens';

export const CreatePopupContainer = forwardRef<HTMLDivElement, any>( // eslint-disable-line @typescript-eslint/no-explicit-any
	({ children, ...props }, ref) => (
		<div css={styles.popup} {...props} ref={ref}>
			{children}
		</div>
	),
);

// Custom shadow value required for design spec
const POPUP_SHADOW = '0 0 1px 0 rgba(30, 31, 33, 0.31), 0 8px 12px 0 rgba(30, 31, 33, 0.15)';

const styles = cssMap({
	popup: {
		overflow: 'visible',
		borderRadius: token('radius.medium'),
		backgroundColor: token('elevation.surface'),
		// @ts-expect-error - Custom shadow value not available in design tokens
		boxShadow: POPUP_SHADOW,
	},
});
